import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { CheckActualShippingCostsView } from './CheckActualShippingCostsView'

export const CheckActualShippingCosts = () => {
    const [orders, setOrders] = useState([])
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        setLoaded(false)
        //fetch db
        axios.post(process.env.REACT_APP_HOST + 'api/actualShippingCosts/get', {
            params: {
                startDate: startDate,
                endDate: endDate
            }
        })
            .then((res) => {
                console.log(res.data)
                setOrders(res.data.filter(order => order.difference > 0 && order.ignore === false))
                setLoaded(true)
            })
    }, [startDate, endDate])

    return <CheckActualShippingCostsView
        orders={orders}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        loaded={loaded}
    />
}